import axios from "axios"
import { fetchAccessToken } from "../utils/token"
import { BRIDGE_URL } from "../utils/constants"
import toast from "react-hot-toast"


// Fetch available appointment days in DB
export const putAppointmentDates = async (locationId, serviceId, staffId = "any") => {

    try {

        if(!locationId || !serviceId) throw new Error("Location ID or Service ID not found")

        const token = localStorage.getItem("oss-token")
        if(!token) fetchAccessToken()


        const headers = {
            Authorization: `Bearer ${token}`
        }

        const formBody = {
            locationId: locationId,
            serviceId: serviceId,
            staffId: staffId,
            random: "key"
        }

        const res = await axios.put(`${BRIDGE_URL("services/apexrest/appointment/days")}`, formBody, { headers })
        if(res.data.length <= 0) {
            toast.error("No dates available for this location")
            return res.data
        }
        return res.data

    } catch (err) {
        console.log(err)
    }

}
